import React, { useRef, useState } from 'react';

import { Button, Flex } from '@revenuemarket/cds';
import { Input, Space, Tag, Tooltip, InputRef } from 'antd';

import { css } from '~libs/emotion';

interface TaggedInputProps {
  tags?: string[];
  setTags: (tags: string[]) => void;
  placeholder?: string;
}

const TaggedInputs: React.FC<TaggedInputProps> = ({ tags = [], setTags, placeholder }) => {
  const [inputValue, setInputValue] = useState('');
  const [editInputIndex, setEditInputIndex] = useState(-1);
  const inputRef = useRef<InputRef>(null);

  const handleClose = (removedTag: string) => {
    const newTags = tags?.filter((tag) => tag !== removedTag);
    setTags(newTags);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && !tags?.includes(inputValue)) {
      setTags([...tags, inputValue]);
    }
    setInputValue('');
  };

  const isComposing = useRef(false);

  const tagInputStyle: React.CSSProperties = {
    width: '100%',
    height: 22,
    verticalAlign: 'top',
  };

  return (
    <Flex direction="column" gap={8}>
      <Space size={[0, 8]} wrap>
        {tags ? (
          tags?.map((tag, index) => {
            const isLongTag = tag.length > 20;
            const tagElem = (
              <Tag
                key={tag}
                closable
                style={{ userSelect: 'none' }}
                onClose={() => handleClose(tag)}
              >
                <span
                  onDoubleClick={(e) => {
                    setEditInputIndex(index);
                    setInputValue(tag);
                    e.preventDefault();
                  }}
                >
                  {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </span>
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })
        ) : (
          <div />
        )}
      </Space>
      <Flex gap={4} align="center" style={{ width: '100%' }}>
        <Input
          ref={inputRef}
          type="text"
          size="small"
          style={tagInputStyle}
          value={inputValue}
          placeholder="입력 후 엔터로 추가"
          onCompositionStart={() => {
            isComposing.current = true;
          }}
          onCompositionEnd={() => {
            isComposing.current = false;
          }}
          onChange={handleInputChange}
          onBlur={(e) => {
            if (e.relatedTarget?.tagName !== 'BUTTON') {
              handleInputConfirm();
            }
          }}
          onPressEnter={(e) => {
            if (!isComposing.current) {
              e.stopPropagation();
              e.preventDefault();
              handleInputConfirm();
            }
          }}
        />
        <Button
          buttonSize="small"
          onClick={handleInputConfirm}
          className={css`
            & div {
              width: max-content !important;
            }
          `}
        >
          추가
        </Button>
      </Flex>
    </Flex>
  );
};

export default TaggedInputs;
